import { BuilderTypes } from "@/api/AppApi/common-interfaces/api-enums";
import { IAppointmentDetails } from "../../product/interfaces/api-product-details-interface";

export interface ICalendarService {
  id: number;
  description: string;
  name: string;

  //new variants
  thumbnail_url: string;
  image_url: string;
}
export enum CalendarStyle {
  beside = "beside",
  inside = "inside",
}
export interface ICalendar {
  index: number;
  type: BuilderTypes.calender;
  configurations: {
    background_image: string;
    key: number | string;
    title: string;
    style_type: CalendarStyle;
  };
  data: IAppointmentDetails;
}
